/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, inject, h } from 'vue';
import { barProps } from './props.js';
import RefLine from './RefLine.js';
import dataToPoints from './utils/dataToPoints.js';
import uid from './utils/uid.js';
import isEmpty from './utils/isEmpty.js';
import './constant.js';
import './_chunks/dep-680ea5a1.js';
import './utils/min.js';
import './utils/max.js';
import './utils/mean.js';
import './utils/midRange.js';
import './utils/median.js';
import './utils/stdev.js';
import './utils/variance.js';
import './utils/debounce.js';
import './utils/genColor.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Bar = defineComponent({
  name: "SparklineBar",
  inheritAttrs: false,
  props: barProps,
  setup: function setup() {
    var eventBus = inject("eventBus");
    var id = uid();
    return {
      eventBus: eventBus,
      id: id
    };
  },
  render: function render() {
    var id = this.id,
        _this$data = this.data,
        data = _this$data === void 0 ? [] : _this$data,
        limit = this.limit,
        width = this.width,
        height = this.height,
        margin = this.margin,
        styles = this.styles,
        max = this.max,
        min = this.min,
        refLineStyles = this.refLineStyles,
        eventBus = this.eventBus;

    if (!data.length) {
      return null;
    }

    var props2 = this.$props;
    var points = dataToPoints({
      data: data,
      limit: limit,
      width: width,
      height: height,
      margin: margin,
      max: max,
      min: min
    });
    var strokeWidth = styles && styles.strokeWidth || 0;
    var marginWidth = margin || 0;
    var nonLimit = data.length === limit;
    var limitedWidth = nonLimit ? (width - limit * (marginWidth + strokeWidth)) / limit : points && points.length >= 2 ? Math.max(0, points[1].x - points[0].x - strokeWidth - marginWidth) : 0;
    var minWidth;

    if (!isNaN(limitedWidth) && limitedWidth < 0) {
      minWidth = 1;
    } else {
      minWidth = limitedWidth;
    }

    if (minWidth === 0) {
      return console.warn("[vue-sparklines]: The limit value is too large.");
    }

    var adjustPos = [];
    var barWidth = styles.barWidth || minWidth;
    return h("g", function () {
      var items = [];
      points.map(function (p, i) {
        var curW = Math.ceil(barWidth);
        var curH = Math.ceil(Math.max(0, height - p.y));
        return items.push(h("rect", {
          style: _objectSpread(_objectSpread({}, styles), {}, {
            width: "".concat(curW, "px"),
            height: "".concat(curH, "px")
          }),
          x: function () {
            adjustPos[i] = adjustPos[i] || {
              x: 0,
              y: 0
            };

            if (nonLimit) {
              var curX2 = Math.ceil((barWidth + strokeWidth + marginWidth) * i + margin);
              adjustPos[i].x = curX2 + barWidth;
              return curX2;
            }

            var curX = Math.ceil(p.x - strokeWidth * i);
            adjustPos[i].x = curX + barWidth;
            return curX;
          }(),
          y: function () {
            return adjustPos[i].y = Math.ceil(p.y);
          }(),
          width: curW,
          height: curH,
          rel: data[i],
          key: i
        }));
      });
      eventBus.updateValue({
        id: "sparkline__".concat(id),
        color: styles.stroke || styles.fill || "#fff",
        data: data,
        points: adjustPos,
        limit: limit,
        type: "bar"
      });
      !isEmpty(refLineStyles) && items.push(h(RefLine, _objectSpread(_objectSpread({}, props2), {}, {
        points: points
      })));
      return items;
    }());
  }
});

export { Bar as default };
//# sourceMappingURL=Bar.js.map
